import { useMutation, useQueryClient } from '@tanstack/react-query';
import { platformApiFetch } from '../../api/client';

export function useCreateSubscription() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      platformApiFetch('/api/platform/subscriptions', {
        method: 'POST',
        body,
        errorMessage: 'Failed to create subscription',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platform', 'organizations'] });
    },
  });
}

export function useUpdateSubscription(uuid) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      platformApiFetch(`/api/platform/subscriptions/${uuid}`, {
        method: 'PATCH',
        body,
        errorMessage: 'Failed to update subscription',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platform', 'organizations'] });
    },
  });
}
